
import { Component, Prop } from '@modules/vue-property-decorator/lib';
import Vue from 'vue';

export interface AccessCodeData {
  content: string;
  contentType: string;
  encoding: string;
}

@Component({})
export default class AccessCode extends Vue {
    @Prop() data!: AccessCodeData;

    private get isImage(): boolean {
        return this.data.contentType.startsWith("image/");
    }
    private get isText(): boolean {
        return this.data.contentType.startsWith("text/");
    }
}

